import { toISO, formatDateRangeBoundary } from "../dates";
import { normaliseSpacing } from "../formatting";

export const transformForApi = {
  text: (value: string) => normaliseSpacing(value),
  identifier: (value: string) => value.replace(/\s+/g, "").toUpperCase(),
  email: (value: string) => value.trim().toLowerCase(),
  date: {
    toISO,
  },
  dateRange: {
    start: formatDateRangeBoundary.start,
    end: formatDateRangeBoundary.end,
  },
};
